export { default } from './LeilaoDeVeiculosFiqueAtento';
